module.exports = __webpack_public_path__ + "static/media/hipercard.1de036c2.svg";